<template>
  <div class="flex flex-col gap-4">
    <div v-if="isLoggedIn" class="flex flex-col gap-2">
      <embed-code />
    </div>
    <div v-else class="flex flex-col items-center gap-4 border border-slate-300 rounded-10 px-3 py-6 text-center">
      <embed-sign-in />
    </div>

    <HorizontalDivider />
    <div class="flex flex-col gap-2">
      <embed-preview />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount } from 'vue';
import { storeToRefs } from 'pinia';
import HorizontalDivider from '@/storybook/utilities/HorizontalDivider.vue';

import { useUserStore } from '@/store/useUserStore';
import { useEmbedStore } from '@/modules/viewer/store/useEmbedStore';

import EmbedCode from '@/modules/viewer/components/share/embed/EmbedCode.vue';
import EmbedSignIn from '@/modules/viewer/components/share/embed/EmbedSignIn.vue';
import EmbedPreview from '@/modules/viewer/components/share/embed/EmbedPreview.vue';

const embedStore = useEmbedStore();

const { isLoggedIn } = storeToRefs(useUserStore());

onBeforeMount(() => {
  embedStore.initIFrame();
});
</script>
